//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'underscore'
import DIC from '@/index/dictionary'

export default {
  components: {
    DialogSelectCourier: () => import('../DialogSelectCourier/index.vue'),
    DialogDetailPick: () => import('../DialogDetailPick/index.vue')
  },
  props: {
    tableData: {
      default: () => []
    },
    loading: {
      default: false
    }
  },
  data: function () {
    return {
      currentTableData: this.tableData,
      rowData: {
        default: () => ({})
      },
      selectCourierDialogVisible: false,
      detailDialogVisible: false,
      successDialogVisible: false,
      DIC: DIC
    }
  },
  watch: {
    tableData: {
      handler (val) {
        this.currentTableData = val
      },
      immediate: true
    }
  },
  methods: {
    handleChoiseCourier (courier) {
      let data = _.extend({pOrderId: this.rowData.pOrderId}, _.pick(courier, 'courierId'))
      this.$axios.post('/mtea/store/admin/purchase/pick/choiseCourier', data).then(res => {
        this.successDialogVisible = true
        // this.$notify.success({
        //   title: '系统提示',
        //   message: '操作成功'
        // })
        this.$emit('submit')
      }).finally(() => {

      })
    },
    handleDeleteRow (row) {
      let data = _.pick(row, 'pOrderId')
      this.$axios.post('/mtea/store/admin/purchase/pick/del', data).then(res => {
        this.$notify.success({
          title: '系统提示',
          message: '操作成功'
        })
        this.$emit('submit')
      }).finally(() => {

      })
    },
    handleConfirmRow (row) {
      let data = {pOrderId: row.pOrderId}
      // console.log('data', data)
      this.$axios.post('/mtea/store/admin/purchase/pick/confirm', data).then(res => {
        this.$notify.success({
          title: '系统提示',
          message: '操作成功'
        })
        this.$emit('submit')
      }).finally(() => {

      })
    }
  }
}
